import { FC, useEffect } from 'react';

import {
  ContactDetailsFormFields,
  Layout,
  NextButton,
  StepHeader,
  useContactDetailsForm,
} from '@eneco/flows/components';
import { useFlowHooks } from '@eneco/flows/utils/FlowProvider';
import { usePlaceholderContent } from '@sitecore/common';
import { ContactDetailsStepRendering } from '@sitecore/types/ContactDetailsStep';

import { FlowContextServiceGemak } from '../../context';

interface FormFields {
  phoneNumber: string;
  emailAddress?: string;
  C1?: boolean;
}

export const ContactDetailsStep: FC = () => {
  const { useFlowSelector, useFlowActorRef } = useFlowHooks<FlowContextServiceGemak>();
  const phoneNumber = useFlowSelector(state => state.context.phoneNumber);
  const emailAddress = useFlowSelector(state => state.context.emailAddress);
  const isPersonalDetailsEditProhibited = useFlowSelector(state => state.context.isPersonalDetailsEditProhibited);
  const C1 = useFlowSelector(state => state.context.C1) || true;
  const sendToFlowMachine = useFlowActorRef().send;

  const { ContactDetailsStep: { fields: textualData } = {} } = usePlaceholderContent<{
    ContactDetailsStep: ContactDetailsStepRendering;
  }>();

  const {
    handleSubmit,
    getValues,
    register,
    formState: { errors, isSubmitSuccessful },
  } = useContactDetailsForm<FormFields>(textualData, { phoneNumber, emailAddress, C1 });

  useEffect(() => {
    if (isSubmitSuccessful) {
      sendToFlowMachine({
        type: 'NEXT_PAGE',
        values: getValues(),
      });
    }
  }, [getValues, isSubmitSuccessful, sendToFlowMachine]);

  return (
    <Layout.Content variant="A" handleSubmit={handleSubmit}>
      <StepHeader textualData={textualData} />
      <ContactDetailsFormFields
        register={register}
        errors={errors}
        textualData={textualData}
        showOptIn={!isPersonalDetailsEditProhibited}
      />
      <NextButton isLoading={isSubmitSuccessful}>{textualData?.content?.nextStepText?.value}</NextButton>
    </Layout.Content>
  );
};
